<template>
  <sliding-modal :is-open="isOpen" @secondary="$emit('secondary')">
    <vk-modal-content class="d-flex fd-column p-0">
      <a
          v-for="cta in ctas"
          :key="cta.key"
          class="d-flex link text-semibold ai-center jc-center bd-b-gray30 p-2"
          :selenium="`job-details-${cta.key}`"
          @click="$emit('primary', cta.key)">
        <vk-icon v-if="cta.icon" :name="cta.icon" class="flex-0-0 h5 m-r-1" />
        {{ getCtaLabel(cta) }}
      </a>
      <a
          key="cancel"
          class="d-flex link-black ai-center jc-center p-2"
          selenium="job-details-cancel"
          @click="$emit('secondary')">
        Close
      </a>
    </vk-modal-content>
  </sliding-modal>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';
import jobParams from '@/mixins/job-params';

export default {
  name: 'action-modal',
  components: {
    SlidingModal,
  },
  mixins: [
    jobParams,
  ],
  props: {
    isOpen: Boolean,
    ctas: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getCtaLabel (cta) {
      return this.$device.isMobile ? (cta.shortLabel || cta.label) : cta.label;
    },
  },
};
</script>
